{
  "processing": "Обработка верификации...",
  "loadingIframe": "Загрузка верификации личности...",
  "issueTitle": "Проблема с верификацией личности",
  "notConfigured": "Верификация личности не настроена должным образом для этого склада.",
  "notSuccessful": "Верификация личности не прошла успешно. Попробуйте снова или свяжитесь со складом.",
  "couldNotCompleteProceed": "Верификация личности не завершена, но вы можете продолжить регистрацию.",
  "processFailed": "Ошибка обработки верификации личности. Попробуйте снова.",
  "processingFailedProceed": "Обработка верификации личности не удалась, но вы можете продолжить регистрацию.",
  "genericError": "Произошла ошибка при верификации личности. Попробуйте снова.",
  "issueProceed": "Верификация личности столкнулась с проблемой, но вы можете продолжить регистрацию.",
  "requiredTryAgain": "Верификация личности необходима для завершения регистрации. Попробуйте снова.",
  "checkInFailedTitle": "Не удалось зарегистрироваться",
  "checkInFailedMessage": "Не удалось подтвердить ваш документ"
}
